<template>
  <div>
    <BannerComponent :banner-url="`${ASSETS_BASE_URL}/images/gallery/backdrop.jpg`" :title="'gallery'|translate"/>
    <div class="uk-container SectionOne">
      <div uk-grid>
        <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s uk-grid-small" uk-grid>
          <div class="uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s" data-aos="fade-up">
            <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
              <div class="uk-cover-container">
                <canvas height="450"></canvas>
                <img class="HotelBackdrop" :src="`${ASSETS_BASE_URL}/images/home/img_1.jpg`" alt="" uk-cover>
                <div class="uk-overlay uk-light uk-position-bottom CanvasDetails">
                  <h3>CASAMIA Nilaveli</h3>
                  <a class="uk-button uk-button-default" href="#gallery-items" uk-toggle
                     @click="onViewGallery(1, 'CASAMIA Nilaveli')">{{'view_gallery'|translate}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s" data-aos="fade-up" data-aos-delay="50">
            <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
              <div class="uk-cover-container">
                <canvas height="450"></canvas>
                <img class="HotelBackdrop" :src="`${ASSETS_BASE_URL}/images/home/img_3.jpg`" alt="" uk-cover>
                <div class="uk-overlay uk-light uk-position-bottom CanvasDetails">
                  <h3>CASAMIA Colombo</h3>
                  <a class="uk-button uk-button-default" href="#gallery-items" uk-toggle
                     @click="onViewGallery(2, 'CASAMIA Colombo')">{{'view_gallery'|translate}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1@l uk-width-1-1@m uk-width-1-1@s" data-aos="fade-up" data-aos-delay="100">
            <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
              <div class="uk-cover-container">
                <canvas height="450"></canvas>
                <img class="HotelBackdrop" :src="`${ASSETS_BASE_URL}/images/home/img_5.jpg`" alt="" uk-cover>
                <div class="uk-overlay uk-light uk-position-bottom CanvasDetails">
                  <h3>Turtle Nest Rekawa</h3>
                  <a class="uk-button uk-button-default" href="#gallery-items" uk-toggle
                     @click="onViewGallery(3, 'Turtle Nest Rekawa')">{{'view_gallery'|translate}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="gallery-items" class="uk-modal-full" uk-modal ref="galleryModal">
      <div class="uk-modal-dialog" v-if="selectedItem">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse" uk-grid>
          <div uk-height-viewport class="uk-width-1-1@l uk-padding">
            <h2><span class="AppTitle">{{'gallery'|translate}}</span> - {{selectedItem.title}}</h2>
            <div class="uk-child-width-1-3@m" uk-grid uk-lightbox="animation: slide" ref="lightBoxModal">
              <div v-if="selectedItem.id === 'property_1'">
                <div class="uk-cover-container uk-height-medium">
                  <iframe
                    src="https://www.youtube.com/embed/DM02YmzrTIE?showinfo=0&amp;controls=1&amp;rel=0&amp;modestbranding=1"
                    width="100%" height="100%"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    frameborder="0" uk-video="automute: true; autoplay: false" allowfullscreen></iframe>
                </div>
              </div>
              <div v-for="(item) in galleryItems[selectedItem.id]" :key="item.title">
                <a :href="`${ASSETS_BASE_URL}${item.img_path}`" :data-caption="selectedItem.title">
                  <div class="uk-cover-container uk-height-medium">
                    <img :src="`${ASSETS_BASE_URL}${item.img_path}`" alt="" uk-cover>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import BannerComponent from '../components/BannerComponent'

export default {
  name: 'Gallery',
  components: { BannerComponent },
  data: function () {
    return {
      selectedItem: null
    }
  },
  methods: {
    fetchGallery (propertyId) {
      this.$store.dispatch('gallery/fetchPropertyGallery', { propertyId })
    },
    onViewGallery: function (id, title) {
      this.fetchGallery(id)
      this.selectedItem = {
        title: title,
        id: `property_${id}`
      }
    }
  },
  computed: {
    galleryItems: function () {
      return store.getters['gallery/propertyGallery']
    }
  },
  beforeDestroy () {
    if (this.$refs.galleryModal) {
      if (this.$refs.lightBoxModal) {
        // eslint-disable-next-line
        UIkit.lightbox(this.$refs.lightBoxModal).hide()
      }
      // eslint-disable-next-line
      UIkit.modal(this.$refs.galleryModal).hide()
    }
  }
}
</script>

<style scoped>
  .SectionOne {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .CanvasDetails {
    text-align: center;
    background: #000000db;
    color: #FFF;
  }
</style>
